import "../css/site.css";
import Alpine from "alpinejs";

window.Alpine = Alpine;

Alpine.start();
